import { debounce } from "@mui/material/utils";
import { useMemo, useState } from "react";

export function useDebouncedValue<T>(initialState: T, wait: number) {
  const [state, setState] = useState(initialState);

  const debouncedSetValue = useMemo(() => {
    return debounce(setState, wait);
  }, [wait]);

  return [state, debouncedSetValue] as const;
}
